import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var LoginRes;
export const LoginTodo = createAsyncThunk('Login', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sign_in',
            data: {
                "phone": data.phone,
                "password": data.password,
                "type": "web",
                // "vcustomer_code":data.vcustomer_code
              
            },
            headers: { "Content-Type": "application/json" }
        })
        return LoginRes = res.data

    } catch (error) {
        return LoginRes = error.response.data
    }
})


export var AperamlogInRes;
// export const AperamlogInTodo = createAsyncThunk('logIn', async (data) => {
//     try {
//         const res = await axios({
//             method: "post",
//             url: process.env.REACT_APP_API_URL_APE + 'login',
//             data: {
//                 "email": data.username,
//                 "password": data.password,
//                 // "vcustomer_code":data.vcustomer_code
              
//             },
//             headers: { "Content-Type": "application/json" }
//         })
//         return AperamlogInRes = res.data

//     } catch (error) {
//         return AperamlogInRes = error.response.data
//     }
// })



